import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { post } from "../../lib/Fetching";

class QuotableSorter extends React.Component {
  state = {
    quotables: this.props.quotables
  };

  getListStyle = isDraggingOver => ({
    // background: isDraggingOver ? 'lightblue' : 'lightgrey',
    // width: 250,
  });

  getItemStyle = (indent, isDragging, draggableStyle) => ({
    userSelect: "none",
    paddingLeft: 5,
    paddingTop: 3,
    paddingBottom: 3,
    paddingLeft: indent,
    borderBottom: 1,
    ...draggableStyle
  });

  save = callback => {
    const { attempt_id } = this.props;
    return post("/attempts/quotable_positions.json", {
      id: attempt_id,
      positions: this.positions()
    })
      .then(callback)
      .catch(e => alert("Could not update positions: " + e.message));
  };

  positions = () => {
    const { quotables } = this.state;
    return quotables.map((quotable, index) => ({
      quote_item_id: quotable.quote_item_id,
      position: index
    }));
  };

  onDragEnd = result => {
    const { quotables } = this.state;
    const { changesMade } = this.props;

    // dropped outside the list
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    // no movement
    if (result.destination.index === result.source.index) {
      return;
    }

    const reorderQuotables = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    };

    const newOrder = reorderQuotables(
      quotables,
      result.source.index,
      result.destination.index
    );

    this.setState({
      quotables: newOrder
    });
  };

  sortAlphabetically = () => {
    const { quotables } = this.state;
    function compare(a, b) {
      const nameA = (a.name || a.test_name).toUpperCase();
      const nameB = (b.name || b.test_name).toUpperCase();
      let comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    }
    this.setState({
      quotables: quotables.sort(compare)
    });
  };

  render() {
    const { quotables } = this.state;
    const { padding } = this.props;
    if (!quotables) return null;
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId={"droppable"} ignoreContainerClipping>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} style={this.getListStyle(snapshot.isDraggingOver)}>
              {quotables.map((quotable, index) => (
                <Draggable
                  key={quotable.quote_item_id}
                  draggableId={quotable.quote_item_id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={this.getItemStyle(
                        padding || 0,
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      <i className="fa fa-arrows">&nbsp;</i>
                      {quotable.name || quotable.test_name}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default QuotableSorter;
